import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-chat',
  templateUrl: './single-chat.component.html',
  styleUrls: ['./single-chat.component.scss']
})
export class SingleChatComponent implements OnInit {
  isCollapsed = true;
  constructor() { }

  ngOnInit(): void {
  }
  slidechat() {
    document.getElementById("show-user-detail").classList.toggle("open-chat-sidebar");
  }

  closechatside() {
    document.getElementById("show-user-detail").classList.remove("open-chat-sidebar");
  }

  slideuserchat() {
    document.getElementById("show-user-detail").classList.toggle("open-user-sidebar");
  }

  closeuserchatside() {
    document.getElementById("show-user-detail").classList.remove("open-user-sidebar");
  }
}
